import React from 'react';

const TableButton = ({ label, disabled, onClick }) => (
    <button
        className="btn btn-primary w-auto rounded-pill scoutViabilityFieldLabel"
        disabled={disabled}
        onClick={onClick}
    >
        {label}
    </button>
);

export default TableButton;
